import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import jwt from 'jwt-decode'
import { cilAccountLogout, cilUser } from '@coreui/icons'
import { AuthContext } from 'src/contexts/authContext'

const AppHeaderDropdown = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const auth = useContext(AuthContext)
  const [authInfo, setAuthInfo] = useState('')

  function signOutClicked() {
    auth.signOut()
    navigate('/')
  }

  const getInitialsUserName = (inputString) => {
    const inputString2 = inputString.trim().replace(/\s\s+/g, ' ')
    const words = inputString2.split(' ')

    if (words.length > 1) {
      const initials = words
        .slice(0, 2)
        .map((word) => word.charAt(0))
        .join('')
      return initials.toUpperCase()
    } else {
      return inputString.slice(0, 2).toUpperCase()
    }
  }

  useEffect(() => {
    if (auth.authStatus === 'SignedIn') {
      if (auth.sessionInfo.idToken) {
        setAuthInfo(jwt(auth.sessionInfo.idToken))
      }
    }
  }, [auth])

  return (
    <CDropdown variant='nav-item' alignment='end'>
      <CDropdownToggle placement='bottom-end' className='py-0' caret={false}>
        <CAvatar color='primary' textColor='white' size='md'>
          {authInfo?.first_name && authInfo?.last_name
            ? getInitialsUserName(`${authInfo?.first_name} ${authInfo?.last_name}`)
            : 'CU'}
        </CAvatar>
      </CDropdownToggle>

      <CDropdownMenu className='pt-0' placement='bottom-end'>
        <CDropdownHeader className='bg-body-secondary text-body-secondary fw-semibold py-2'>
          <CIcon icon={cilUser} className='me-2' />
          {t('Global.UserInformation')}
        </CDropdownHeader>
        <div className='py-2 px-3'>
          {authInfo?.first_name && authInfo?.last_name ? (
            <p>
              {authInfo?.first_name} {authInfo?.last_name}
            </p>
          ) : (
            <p>{'Devies User'}</p>
          )}

          <p className='my-0'> {authInfo?.email && authInfo.email}</p>
        </div>
        <CDropdownDivider />
        <CDropdownItem href='/' onClick={signOutClicked}>
          <CIcon icon={cilAccountLogout} className='me-2' />
          {t('Logout')}
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
